import React, { useState, useCallback, useEffect, useRef } from 'react';
import moment from 'moment';
import Filter from '@/pages/intelligence/components/Filter';
import { STATIC_FILTER_CONFIGS, DEFAULT_FORM_VALUE } from './config';
import GuideGenreMarketProfile from '@intelligence/components/UserGuide/GenreMarketProfile';

export default function Filters(props) {
  const { date, isMarketTypeSegmentHide, onFilterChange, marketType } = props;

  const formValueRef = useRef(JSON.parse(JSON.stringify(DEFAULT_FORM_VALUE)));

  const [formItemList, setFormItemList] = useState([
    STATIC_FILTER_CONFIGS.RANGE_TIME,
    marketType === 'mobile' ? STATIC_FILTER_CONFIGS.DATASOURCESIM : '',
  ]);

  const handleFilterChange = (
    value /** 筛选器数据 */,
    apiValue /** 筛选器转换后的数据 */,
  ) => {
    const { rangeTime, dataSourceSingle } = apiValue || {};
    const { end_date } = rangeTime || {};
    onFilterChange({
      type: 'date',
      payload: end_date,
      dataSourceSingle: dataSourceSingle?.value,
    });
  };

  const onReset = useCallback((value) => {
    // console.log(value);
  }, []);

  /** 时间筛选器值由父组件更新 */
  useEffect(() => {
    formValueRef.current = {
      ...formValueRef.current,
      dataSourceSingle: { value: date.dataSourceSingle },
      rangeTime: {
        type: 'date',
        value: [moment(date.selected), moment(date.selected)],
      },
    };
  }, [date.selected, date.dataSourceSingle]);

  return (
    <>
      <div className="dbi-insights-page-filter">
        <Filter
          value={formValueRef.current}
          inputList={formItemList}
          onConfirm={handleFilterChange}
          onReset={onReset}
          defaultValue={DEFAULT_FORM_VALUE}
          showButton={false}
        />
      </div>
      {!isMarketTypeSegmentHide && <GuideGenreMarketProfile />}
    </>
  );
}
